import {Component, Injector, OnInit} from '@angular/core';
import { LoadsService } from "../../../services/loads/loads.service";
import {SimpleEntity} from "../../../models/simple-entity.model";
import {BaseFormComponentComponent} from "../../../shared/base-form-component/base-form-component.component";
import {WhForwardingModel} from "../../../models/loads/wh-forwarding.model";
import {WhForwardingPackEditModel} from "../../../models/loads/wh-forwarding-pack-edit.model";
import {tryCatch} from "rxjs/internal-compatibility";
import {WhStockModel} from '../../../models/loads/wh-stock.model';

@Component({
  selector: 'app-request-editing',
  templateUrl: './request-editing.component.html',
  styleUrls: ['./request-editing.component.scss']
})
export class RequestEditingComponent extends  BaseFormComponentComponent implements OnInit {


   whForwardings: SimpleEntity[] = [];
   whForwarding: WhForwardingModel = null;
    status = 'PENDING';


  constructor(protected injector: Injector, private loadService: LoadsService) {
    super(injector);
  }

  async ngOnInit() {
      this.whForwardings = await this.loadService.getWhForwardings(this.status).toPromise();
      console.log(this.whForwardings, "forwardings");

  }

  async getWhForwarding(whForwarding: WhForwardingModel) {
      this.whForwarding = await this.loadService.getWhForwarding(whForwarding.id).toPromise();
  }

  async save() {
    try {
      this.isLoading = true;
      await  this.loadService.createOrUpdateWhForwarding(this.whForwarding).toPromise();
      this.isLoading = false;
      this.showMessage('success', '', 'Kayıt başarılı.')
    } catch  {
      this.isLoading = false;
    }

  }
  deleteProduct(product: WhForwardingPackEditModel) {
    this.confirm().then(() => {
      product.quantity = 0;
      this.save().then(() => this.getWhForwarding(this.whForwarding))
    })
  }
  async delete(whForwarding: WhForwardingModel) {
    await this.confirm().then(async () => {
      this.isLoading = true;
      try {
        await this.loadService.deleteWhForwarding(whForwarding.id).toPromise();
        this.whForwardings = await this.loadService.getWhForwardings(this.status).toPromise();
        this.whForwarding = null;
        this.isLoading = false;
        this.showMessage('success', '', 'İşlem başarılı.')
      } catch {
        this.isLoading = false;
      }

    })
  }
  onInputQuantity(product: WhForwardingPackEditModel) {
      console.log(product)
    setTimeout(() => {
      if(product.quantity > this.getTotalStockByStocks(product.whStock)) {
        product.quantity = null;
        this.showMessage('warn', 'Uyarı', `En fazla ${this.getTotalStockByStocks(product.whStock)} adet talep edebilirsiniz.`);
      }
    }, 500)
  }

    getTotalStockByStocks(mainStock: WhStockModel) {
        if (mainStock.stocks) {
            let totalStock = 0;
            mainStock.stocks.forEach(stock => {
                totalStock += stock.stock;
            });
            return totalStock;
        }
        return mainStock.stock;
    }
}
